import initializeComponent from 'Shared/react-initialize';
import { withBreakpointsContext } from 'Shared/utils/breakpoints';
import HeaderInteractive from './header-interactive';
import { MobileAppCartDrawer } from './components/dropdowns/cart_drawer_wrapper';
import './menu-analytics';

if (App.isLoggedIn) {
   void import('Shared/Notifications/notification_service').then(
      ({ initializeNotificationsService }) => initializeNotificationsService()
   );
}

initializeComponent('HeaderInteractive', withBreakpointsContext(HeaderInteractive));
initializeComponent('MobileAppCartDrawer', MobileAppCartDrawer);
